module.exports = __webpack_public_path__ + "img/u20440.d431a826.png";